"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["success", "size"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SuccessIcon = function SuccessIcon(_ref) {
  var success = _ref.success,
      size = _ref.size,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledSuccessIcon, (0, _extends2["default"])({}, rest, {
    size: size,
    success: success
  }), success ? /*#__PURE__*/_react["default"].createElement(StyledCheck, null) : /*#__PURE__*/_react["default"].createElement(StyledCross, null));
};

SuccessIcon.propTypes = {
  className: _propTypes["default"].string,
  success: _propTypes["default"].bool,
  size: _propTypes["default"].number
};
SuccessIcon.defaultProps = {
  className: '',
  size: 60,
  success: true
};

var StyledCheck = _styledComponents["default"].div.withConfig({
  displayName: "SuccessIcon__StyledCheck",
  componentId: "sc-1d9ynu8-0"
})(["position:relative;display:inline-block;&::after{content:\"\";position:absolute;height:50%;left:0;right:0;background:none;border-left:2px solid;border-bottom:2px solid;transform:rotate(-45deg) translateX(-5%) translateY(5%);border-color:#ffffff;}"]);

var StyledCross = _styledComponents["default"].div.withConfig({
  displayName: "SuccessIcon__StyledCross",
  componentId: "sc-1d9ynu8-1"
})(["position:relative;display:inline-block;&::before,&::after{content:\"\";position:absolute;height:5%;min-height:1px;max-height:3px;width:100%;top:50%;left:0;margin-top:-1px;background:#ffffff;}&::before{transform:rotate(45deg);}&::after{transform:rotate(-45deg);}"]);

var StyledSuccessIcon = _styledComponents["default"].div.withConfig({
  displayName: "SuccessIcon__StyledSuccessIcon",
  componentId: "sc-1d9ynu8-2"
})(["min-width:15px;min-height:15px;border-radius:100%;display:inline-flex;justify-content:center;align-items:center;text-align:start;", ";background-color:#ffffff;background-image:", ";", ",", "{", "}"], function (_ref2) {
  var size = _ref2.size;
  return (0, _styledComponents.css)(["width:", "px;height:", "px;;"], size, size);
}, function (props) {
  return props.success ? (0, _styledComponents.css)(["linear-gradient(to right,rgb(0,224,75),rgb(0,176,182));"]) : (0, _styledComponents.css)(["linear-gradient(to top,rgb(255,128,0),rgb(207,0,69))"]);
}, StyledCheck, StyledCross, function (_ref3) {
  var size = _ref3.size;
  return (0, _styledComponents.css)(["width:", "px;height:", "px;"], size / 2, size / 2);
});

var _default = SuccessIcon;
exports["default"] = _default;